import React from "react";

const NoData = ({ title, text }) => {
  return (
    <>
      <div className="middle -no-margin">
        <h3>{title}</h3>
        <span className="-small">{text}</span>
      </div>
    </>
  );
};

export default NoData;
